import apiClient from '@u/apiClient.js'
import CreateAvailabilityItemController from '@/wayfinder/actions/App/Http/Controllers/AvailabilityItem/CreateAvailabilityItemController'
import UpdateAvailabilityItemController from '@/wayfinder/actions/App/Http/Controllers/AvailabilityItem/UpdateAvailabilityItemController'
import FetchAvailabilityItemController from '@/wayfinder/actions/App/Http/Controllers/AvailabilityItem/FetchAvailabilityItemController'
import DeleteAvailabilityItemController from '@/wayfinder/actions/App/Http/Controllers/AvailabilityItem/DeleteAvailabilityItemController'

export default {
  addUnavailabilityItem({ commit, state }, payload) {
    if (state.mutateController) {
      state.mutateController.abort()
      state.mutateController = undefined
    }

    state.mutateLoading = true

    state.mutateController = new AbortController()
    return new Promise((resolve, reject) => {
      apiClient
        .route(CreateAvailabilityItemController.post(), payload.data, {
          signal: state.mutateController.signal
        })
        .then((response) => resolve(response.data))
        .catch((reason) => {
          reject(reason)
        })
        .finally(() => {
          state.mutateLoading = false
        })
    })
  },
  updateUnavailabilityItem({ commit, state }, payload) {
    if (state.mutateController) {
      state.mutateController.abort()
      state.mutateController = undefined
    }

    state.mutateLoading = true

    state.mutateController = new AbortController()
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateAvailabilityItemController.put({
            availability_item: payload.id
          }),
          payload.data,
          {
            signal: state.mutateController.signal
          }
        )
        .then((response) => resolve(response.data))
        .catch((reason) => {
          reject(reason)
        })
        .finally(() => {
          state.mutateLoading = false
        })
    })
  },
  fetchUnavailabilityItems({ commit, state }, payload) {
    if (state.fetchController) {
      state.fetchController.abort()
      state.fetchController = undefined
    }
    state.fetchLoading = true
    state.fetchController = new AbortController()
    return new Promise((resolve, reject) => {
      apiClient
        .route(FetchAvailabilityItemController.get(), {
          params: payload,
          signal: state.fetchController.signal
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
          console.error('Error : ', reason)
        })
        .finally(() => {
          state.fetchLoading = false
        })
    })
  },
  deleteUnavailabilityItems({ commit, state }, payload) {
    if (state.fetchController) {
      state.fetchController.abort()
      state.fetchController = undefined
    }
    state.fetchLoading = true
    state.fetchController = new AbortController()
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteAvailabilityItemController.delete.delete({
            availability_item: payload.id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
        .finally(() => {
          state.fetchLoading = false
        })
    })
  },
  undoDeleteUnavailabilityItems({ commit, state }, payload) {
    if (state.fetchController) {
      state.fetchController.abort()
      state.fetchController = undefined
    }
    state.fetchLoading = true
    state.fetchController = new AbortController()
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteAvailabilityItemController.undo.get({
            availability_item: payload.id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
        .finally(() => {
          state.fetchLoading = false
        })
    })
  }
}
